import { render, staticRenderFns } from "./Dots.vue?vue&type=template&id=7c99e404&scoped=true"
import script from "./Dots.vue?vue&type=script&lang=js"
export * from "./Dots.vue?vue&type=script&lang=js"
import style0 from "./Dots.vue?vue&type=style&index=0&id=7c99e404&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c99e404",
  null
  
)

export default component.exports